import React, { useEffect, useState } from 'react';
import GundamCard from './GundamCard/GundamCard';
import './RecommendedList.scss';
import apiClient from '../../../helpers/apiClient';
import { apiPath } from '../../../config';

const RecommendedList = ({ productData }) => {
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const isAccessories = ['classification', 'type'].some(key =>
    productData?.[key]?.toLowerCase().includes('accessories')
  );

  useEffect(() => {
    if (!productData.id) return;

    const client = apiClient();
    client.setHeader();

    const getRecommendedProducts = async () => {
      try {
        const url = `${apiPath.recommendedProducts}${productData.id}/similar-products?page=0&page-size=15`;
        const res = await client.get(url);

        if (Number(res?.status) === 200) {
          setRecommendedProducts(res?.result?.product_list || []);
        }
      } catch (err) {
        console.error('Failed to get recommended products:', err);
      }
    };

    getRecommendedProducts();
  }, [productData.id]);

  const filteredData = recommendedProducts.filter(item => item?.id !== Number(productData.id));

  if (isAccessories) return null;

  return (
    <div className="recommended-list">
      <h2 className="recommended-list__title">Similar Products</h2>
      <div className="recommended-list__slider">
        <div className="recommended-list__slider-list">
          {filteredData.map(item => (
            <GundamCard key={item?.id} product={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecommendedList;
